import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface RandomStates {
  darkMode: boolean;
  activityTogglePopup: boolean;
  activityTogglePopupTwo: boolean;
  toggleAddCampaign: boolean;
  themeSettings: boolean;
  modalTitle: string;
  addTogglePopupTwo: boolean;
  headerCollapse: boolean;
  mobileSidebar: boolean;
  miniSidebar: boolean;
  expandMenu: boolean;
  imageUrl: string | null;
  selectedContactData: null,
  columnSettings: ColumnItem[];
  projectId: null,
  projectData:null,
  projectPages:''
}
interface ColumnItem {
  id: number;
  name: string;
  checked: boolean;
}
const initialState: RandomStates = {
  darkMode: false,
  activityTogglePopup: false,
  activityTogglePopupTwo: false,
  toggleAddCampaign: false,
  themeSettings: false,
  projectId: null,
  modalTitle: '',
  addTogglePopupTwo: false,
  headerCollapse: false,
  mobileSidebar: false,
  miniSidebar: false,
  expandMenu: false,
  imageUrl: null,
  selectedContactData: null,
  columnSettings: [],
  projectData:null,
  projectPages:''
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setContactsData: (state, action) => {
      state.selectedContactData = action.payload;
    },
    setDarkMode: (state, { payload }) => {
      state.darkMode = payload;
    },
    setActivityTogglePopup: (state, { payload }) => {
      state.activityTogglePopup = payload;
    },
    setAddTogglePopupTwo: (state, { payload }) => {
      state.addTogglePopupTwo = payload;
    },
    setActivityTogglePopupTwo: (state, { payload }) => {
      state.activityTogglePopupTwo = payload;
    },
    setToggleAddCampaign: (state, { payload }) => {
      state.toggleAddCampaign = payload;
    },
    setThemeSettings: (state, { payload }) => {
      state.themeSettings = payload;
    },
    setModalTitle: (state, { payload }) => {
      state.modalTitle = payload;
    },
    setHeaderCollapse: (state, { payload }) => {
      state.headerCollapse = payload;
    },
    setMobileSidebar: (state, { payload }) => {
      state.mobileSidebar = payload;
    },
    setMiniSidebar: (state, { payload }) => {
      state.miniSidebar = payload;
    },
    setProjectId: (state, { payload }) => {
      state.projectId = payload;
    },
    setProjectData: (state, { payload }) => {
      state.projectData = payload;
    },
    setProjectPages: (state, { payload }) => {
      state.projectPages = payload;
    },
    setExpandMenu: (state, { payload }) => {
      state.expandMenu = payload;
    },
    setImage(state, action: PayloadAction<string>) {
      state.imageUrl = action.payload;
    },
    removeImage(state) {
      state.imageUrl = null;
    },
    setColumnSettings: (state, { payload }: PayloadAction<ColumnItem[]>) => {
      state.columnSettings = payload;
    },

  },
});

export const {
  setDarkMode,
  setToggleAddCampaign,
  setAddTogglePopupTwo,
  setActivityTogglePopup,
  setHeaderCollapse,
  setMobileSidebar,
  setMiniSidebar,
  setExpandMenu,
  setActivityTogglePopupTwo,
  setThemeSettings,
  setModalTitle,
  setImage,
  removeImage,
  setContactsData,
  setColumnSettings,
  setProjectId,
  setProjectData,
  setProjectPages
} = commonSlice.actions;


export const { actions, reducer: commonReducer } = commonSlice;